import Tippy from "@tippyjs/react";
import { AddCircle, Clock, Danger, RecordCircle } from "iconsax-react";
import { JOURNEY_OVERVIEW_STATUS } from "../../store/types/journeyControl";
import { formatSeconds } from "../../utils/functions/formatters";

interface ExpandableDatatableBoxProps {
  title: string;
  time?: number;
  infractions?: number;
  events?: number;
  status: JOURNEY_OVERVIEW_STATUS
}

const ExpandableDatatableBox: React.FC<ExpandableDatatableBoxProps> = ({
  title,
  time,
  infractions,
  events,
  status
}) => {
  let iconColor = "";
  let tippyText = "";

  switch(status) {
    case JOURNEY_OVERVIEW_STATUS.OK :
      iconColor = "#4CAF50";
      tippyText = "Consta";
      break;

    case JOURNEY_OVERVIEW_STATUS.NOK :
      iconColor = "#DA1E27";
      tippyText = "Não consta";
      break;

    case JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS :
      iconColor = "#FB8C00";
      tippyText = "Consta com ressalvas";
      break;
  }

  return (
    <div className="py-3 px-3 mb-3 w-[180px] border-gray_0 border-2 border-solid rounded-lg">
      <div className="flex justify-between items-center">
        <p className="font-extralight text-sm">{title}</p>
        <Tippy
          content={tippyText}
          className="px-2 py-1 bg-gray_3 text-sm rounded-md text-white font-medium"
          duration={1}
        >
          <RecordCircle
            size="15"
            color={iconColor}
            variant="Bulk"
          />
        </Tippy>
        
      </div>
      <div className="flex mt-4 items-center">
        <Clock
          size="16"
          color="#000000"
        />
        <p className="text-sm ml-2">{time != null ? formatSeconds(time) : "-"}</p>
      </div>
      <div className="flex mt-2 items-center">
        <Danger
          size="16"
          color="#000000"
        />
        <p className="text-sm ml-2">{infractions} infrações</p>
      </div>
      <div className="flex mt-2 items-center">
        <AddCircle
          size="16"
          color="#000000"
        />
        <p className="text-sm ml-2">{events} eventos</p>
      </div>
    </div>
  );
};

export default ExpandableDatatableBox;
